import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-ffurflen-diogelwch',
    templateUrl: './ffurflen-diogelwch.component.html',
    styleUrls: ['./ffurflen-diogelwch.component.scss'],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, FormlyModule, UpperCasePipe, TranslatePipe]
})
export class FfurflenDiogelwchComponent extends FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}
